import axios from 'axios'
import { newAxiosIns } from '@/libs/axios'
import secureLocalStorage from '@/libs/secureLocalstorage'
import useJwt from '@/auth/jwt/useJwt'
import ability from '@/libs/acl/ability'
import navigation from '@/navigation/vertical/index'

export default {
  namespaced: true,
  state: {
    userData: localStorage.getItem('userData') ? JSON.parse(localStorage.getItem('userData')) : {},
  },
  mutations: {
    UPDATE_USER_DATA(state, val) {
      state.userData = val
    },
  },
  actions: {
    async refreshUserAccess({ commit, state, dispatch }) {
      const { userData } = state
      const token = secureLocalStorage.get(useJwt.jwtConfig.storageTokenKeyName)
      if (!userData || !userData.id || !token) return

      const usernameEmail = userData.email || userData.username
      if (!usernameEmail) return

      const params = `username_email=${usernameEmail}`
      const url = `v1/user_access/detail?${params}`

      try {
        const response = await axios.get(`${process.env.VUE_APP_BASE_URL_KOMTIM}/${url}`, {
          headers: { Authorization: `Bearer ${token}` },
        })
        const { data } = response.data
        let userAccess = []
        if (data && data.menu_access) {
          userAccess = data.menu_access
            .filter(e => e.id !== 0 && e.name.trim() !== '')
            .map(e => {
              if (e.parent_id) return ({ action: 'manage', subject: `${e.parent_name} - ${e.name}` })
              return ({ action: 'manage', subject: e.name })
            })
        }
        dispatch('menuAdmin/getMenuAdmin', null, { root: true })

        let isAllowed = false
        try {
          const resAllowed = await newAxiosIns.get('/moota/api/v1/auth/is-allowed', {
            headers: { Authorization: `Bearer ${token}` },
          })
          isAllowed = resAllowed.data?.data?.allow || false
        } catch (err) {
          console.error('Failed to check isAllowed status:', err)
        }

        const role = userData.role_name ? userData.role_name.toUpperCase() : ''
        let dynamicAbility = []

        if (['ADMIN'].includes(role)) {
          // Generate dynamic navigation for admin users
          const resourceSet = new Set()
          navigation.forEach(section => {
            if (section.resource) {
              resourceSet.add(section.resource)
            }
            if (Array.isArray(section.children)) {
              section.children.forEach(child => {
                if (child.resource) {
                  resourceSet.add(child.resource)
                }
              })
            }
          })
          const allSubjects = [...resourceSet].filter(subject => subject !== 'MutationBank')

          dynamicAbility = allSubjects.map(subject => ({
            action: 'manage',
            subject,
          }))

          dynamicAbility.unshift({ action: 'read', subject: 'Dashboard' })

          if (isAllowed) {
            dynamicAbility.push({ action: 'manage', subject: 'MutationBank' })
          }
        } else {
          dynamicAbility = [{ action: 'read', subject: 'Dashboard' }, ...userAccess]
          if (isAllowed) {
            dynamicAbility.push({ action: 'manage', subject: 'MutationBank' })
          }
        }

        const updatedUserData = { ...userData, ability: dynamicAbility }

        // Update local storage, store and Casl
        localStorage.setItem('userData', JSON.stringify(updatedUserData))
        commit('UPDATE_USER_DATA', updatedUserData)
        ability.update(dynamicAbility)
      } catch (error) {
        console.error('Error refreshing user access:', error)
      }
    },
  },
}
